<i18n>
{
	"en": {
		"priceLines": "Pricelines",
		"noPriceLines": "There are no pricelines yet.",
		"chargeCode": "Code",
		"currency": "Currency",
		"amount": "Amount",
		"text": "Text"
	},
	"no": {
		"priceLines": "Prislinjer",
		"noPriceLines": "Det er ingen prislinjer ennå.",
		"chargeCode": "Kode",
		"currency": "Valuta",
		"amount": "Beløp",
		"text": "Tekst"
	}
}
</i18n>
<template>
	<div class="pricelines">
		<div class="pricelines-header">
			<t-panel-header
				:text="$t('priceLines')"
				icon="dollar"
				type="bp"
				size="md"
			/>
		</div>

		<t-grid
			v-if="priceLines && priceLines.length"
			ref="grid"
			:columnDefinitions="columnDefinitions"
			:rowHeight="50"
			:items="priceLines"
			:showFilters="false"
			class="pricelines-content"
		>
			<template #field="{ item }">
				<t-text-input
					v-model="item.field"
					:disabled="orderIsLocked"
				/>
			</template>
		</t-grid>

		<t-no-content-panel
			v-else
			class="pricelines-content"
			:text="$t('noPriceLines')"
			icon="dollar"
			iconType="bp"
			noBetweenGap
		/>
	</div>
</template>

<script>
import { formatNumber } from '@/core';
import { mapGetters } from '@/modules/newOrder/store/newOrder.store';

export default {
	name: 'PriceLines',
	props: {
		order: Object,
		events: Object,
	},
	computed: {
		...mapGetters(['orderIsLocked']),

		columnDefinitions() {
			return [
				{
					field: 'lineNo',
					displayName: '#',
					width: 50,
					center: true,
				},
				{
					field: 'chargeCode',
					displayName: this.$t('chargeCode'),
					width: 100,
					resizable: true,
				},
				{
					field: 'originalCurrency',
					displayName: this.$t('currency'),
					width: 100,
					resizable: true,
				},
				{
					field: 'amount',
					displayName: this.$t('amount'),
					valueGetter: (item) => item.amount ? formatNumber(item.amount) : 0,
					width: 100,
					resizable: true,
				},
				{
					field: 'text',
					displayName: this.$t('text'),
					minWidth: 150,
					resizable: true,
				},
			];
		},
		priceLines() {
			return this.order.priceLines || [];
		}
	},
};
</script>

<style lang="scss" scoped>
.pricelines {
	height: 100%;
	min-height: inherit;
}

.pricelines-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 15px;
	background: white;
}

.pricelines-content {
	height: calc(100% - 60px);
	width: 100%;
	min-height: inherit;
}
</style>

